import { createSlice } from "@reduxjs/toolkit";

export const FaxSlice = createSlice({
  name: "fax",
  initialState: {
    isCheckedFax: false,
    isFaxInvalid: null,
    fax: "",
  },
  reducers: {
    changeFax: (state, action) => {
      state.fax = action.payload;
    },
    changeIsCheckedFax: (state, action) => {
      state.isCheckedFax = action.payload;
    },
    changeIsFaxInvalid: (state, action) => {
      state.isFaxInvalid = action.payload;
    },
  },
});

export const { changeFax, changeIsCheckedFax, changeIsFaxInvalid } =
  FaxSlice.actions;
export default FaxSlice.reducer;
